import styled from "styled-components";
import { BASIC_BROWN, BASIC_YELLOW } from "../../constants/colors";

type Props = {
  onDownloadApp: () => void;
};

export const AppCouponFooter: React.FC<Props> = ({ onDownloadApp }) => {
  return (
    <FooterContainer>
      <FooterContent>
        <img
          src={require("../../assets/app_coupon/logo.png")}
          alt="Download App"
        />
        <div>
          <FooterText>アプリをお持ちでない方は</FooterText>
          <FooterText>
            <FooterLink onClick={onDownloadApp}>こちら</FooterLink>
            からダウンロードできます
          </FooterText>
        </div>
      </FooterContent>
    </FooterContainer>
  );
};

const FooterContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  min-width: 375px;
  z-index: 9998;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${BASIC_BROWN};
  padding: 20px 0px;
`;

const FooterText = styled.div`
  color: white;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  margin: 0 10px;
`;

const FooterLink = styled.span`
  color: ${BASIC_YELLOW};
  text-decoration: underline;
  cursor: pointer;
`;
